import React, { PropsWithChildren } from 'react';

import { Button, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { useTranslation } from 'react-i18next';

import { AccountDefinitionMaped } from '../../../../../api/accounts';
import { PammInvestmentAccountData } from '../CreateInvestment';

export function MoneyManager({
  moneyManagersAccounts,
  accountData,
}: PropsWithChildren & {
  moneyManagersAccounts: AccountDefinitionMaped[];
  accountData: [
    PammInvestmentAccountData,
    React.Dispatch<React.SetStateAction<PammInvestmentAccountData>>,
  ];
}) {
  const { t } = useTranslation('offerStepper');
  return (
    <Formik
      initialValues={accountData[0]}
      onSubmit={(values) =>
        accountData[1]((prev) => ({
          ...prev,
          ...values,
          activeStep: values.ownerId ? 3 : 2,
        }))
      }
    >
      <Form>
        <Field
          component={TextField}
          select
          name="ownerId"
          label={t('investorAccount')}
          margin="normal"
          fullWidth
        >
          {moneyManagersAccounts.map((item) => (
            <MenuItem value={Number(item.login)} key={item.id}>
              {item.login} {item.name}
            </MenuItem>
          ))}
        </Field>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
            variant="contained"
            color="inherit"
            disabled={accountData[0].activeStep === 0}
            onClick={() => {
              accountData[1]((prev) => ({
                ...prev,
                activeStep: 1,
              }));
            }}
            sx={{ mr: 1 }}
          >
            {t('back')}
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button type="submit" variant="contained">
            {t('next')}
          </Button>
        </Box>
      </Form>
    </Formik>
  );
}
